var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TriggerButton",style:({ backgroundColor: _vm.backgroundColor,
                     color: _vm.triggerColor }),on:{"click":_vm.handleClick}},[(!_vm.isPlaying)?_c('span',[_vm._v("▶")]):_c('span',[_vm._v("◼")])])}
var staticRenderFns = []

export { render, staticRenderFns }